module.exports = "<section class=\"nn-ecommerce container--large\"><nn-tracking-pixel code=ecomerceItem.tracking></nn-tracking-pixel><div class=nn-ecommerce__content><div class=nn-ecommerce__background lazy-background=\"{{ ::ecomerceItem.imageUrl }}\"></div><div class=nn-ecommerce__text><h2 class=h2 ng-bind-html=::item.title></h2><nn-base-button class=btn href=::ecomerceItem.url ng-click=\"toEcommerce(brandName, ecomerceItem)\">{{ $root.$bp === 'ltMobileXS' ? ecomerceItem.buttonTextMobile : ecomerceItem.buttonText }}</nn-base-button></div></div></section>"


//////////////////
// WEBPACK FOOTER
// ./app/components/nn-modules/nn-ecommerce/nn-ecommerce.directive.html
// module id = 993
// module chunks = 0